import { AdaptiveDpr, useContextBridge } from '@react-three/drei'
import { Canvas as ThreeCanvas, useThree } from '@react-three/fiber'
import type { Props as ThreeCanvasProps } from '@react-three/fiber'
import type { CSSProperties, FunctionComponent } from 'react'
import { useEffect } from 'react'
import ResizeObserver from 'resize-observer-polyfill'

import { MouseContext } from '../../lib/context/mouse'
import { ScrollContext } from '../../lib/context/scroll'

interface CanvasProps extends ThreeCanvasProps {
    style?: CSSProperties
    className?: string
}

function AdaptivePixelRatio() {
    const {
        performance: { regress },
    } = useThree()

    useEffect(() => {
        regress()
    }, [regress])

    return <AdaptiveDpr pixelated />
}

export const Canvas: FunctionComponent<CanvasProps> = ({
    children,
    style,
    className,
    frameloop = 'demand',
    ...rest
}) => {
    const ContextBridge = useContextBridge(MouseContext, ScrollContext)

    return (
        <ThreeCanvas
            dpr={[1, 2]}
            camera={{ position: [0, 0, 10], fov: 40 }}
            style={style}
            className={className}
            resize={{ polyfill: ResizeObserver }}
            frameloop={frameloop}
            performance={{ min: 0.2, max: 1, debounce: 500 }}
            {...rest}
        >
            <ContextBridge>{children}</ContextBridge>
            <AdaptivePixelRatio />
        </ThreeCanvas>
    )
}
